export default {
  MILLISECONDS: 1000,
  SECONDS: 60,
  MINUTES: 60,
  HOURS: 24,
  COUNT_DAY: 6,
  COUNT_MONTH: 4,

  SECONDS_PER_MINUTE: 60,

  MAX_LENGTH: 50,

  scatterplotYLabels:[
    {id: 1, text: '00:00-00:29'},
    {id: 2, text: '00:30-00:59'},
    {id: 3, text: '01:00-01:29'},
    {id: 4, text: '01:30-01:59'},
    {id: 5, text: '02:00-02:29'},
    {id: 6, text: '02:30-02:59'},
    {id: 7, text: '03:00-03:29'},
    {id: 8, text: '03:30-03:59'},
    {id: 9, text: '04:00-04:29'},
    {id: 10, text: '04:30-04:59'},
    {id: 11, text: '05:00-05:29'},
    {id: 12, text: '05:30-05:59'},
    {id: 13, text: '06:00-06:29'},
    {id: 14, text: '06:30-06:59'},
    {id: 15, text: '07:00-07:29'},
    {id: 16, text: '07:30-07:59'},
    {id: 17, text: '08:00-08:29'},
    {id: 18, text: '08:30-08:59'},
    {id: 19, text: '09:00-09:29'},
    {id: 20, text: '09:30-09:59'},
    {id: 21, text: '10:00-10:29'},
    {id: 22, text: '10:30-10:59'},
    {id: 23, text: '11:00-11:29'},
    {id: 24, text: '11:30-11:59'},
    {id: 25, text: '12:00-12:29'},
    {id: 26, text: '12:30-12:59'},
    {id: 27, text: '13:00-13:29'},
    {id: 28, text: '13:30-13:59'},
    {id: 29, text: '14:00-14:29'},
    {id: 30, text: '14:30-14:59'},
    {id: 31, text: '15:00-15:29'},
    {id: 32, text: '15:30-15:59'},
    {id: 33, text: '16:00-16:29'},
    {id: 34, text: '16:30-16:59'},
    {id: 35, text: '17:00-17:29'},
    {id: 36, text: '17:30-17:59'},
    {id: 37, text: '18:00-18:29'},
    {id: 38, text: '18:30-18:59'},
    {id: 39, text: '19:00-19:29'},
    {id: 40, text: '19:30-19:59'},
    {id: 41, text: '20:00-20:29'},
    {id: 42, text: '20:30-20:59'},
    {id: 43, text: '21:00-21:29'},
    {id: 44, text: '21:30-21:59'},
    {id: 45, text: '22:00-22:29'},
    {id: 46, text: '22:30-22:59'},
    {id: 47, text: '23:00-23:29'},
    {id: 48, text: '23:30-23:59'},
  ]
};



// WEBPACK FOOTER //
// ./src/modules/undesirableBehavior/Constants.js